var TorsoNestedModel = require('backbone-torso/modules/NestedModel');
var loadingMixin = require('backbone-torso/modules/mixins/loadingMixin');
var onsiteFeatureConfigService = require('./../urls').onsiteFeatureConfigService;

/**
 * Model for onsite configuration information.
 *
 * @static onsiteConfigModel
 * @extends Torso.NestedModel
 * @constructor
 */
var OnsiteConfigModel = TorsoNestedModel.extend({
  urlRoot: onsiteFeatureConfigService,
  /**
   * Extends the loadingMixin's methods with a method that both fetches (if not already fetched or fetching) and
   * returns a promise that will resolve once the fetch completes (or immediately if already fetched).
   * @returns {$.Deferred.Promise}
   */
  loadOnce: function () {
    if (!this.loadedOnce && !this.loading) {
      this.fetch(arguments);
    } else {
      this.trigger('load-complete');
    }
    return this.getLoadedOncePromise();
  }
});

OnsiteConfigModel = OnsiteConfigModel.extend(loadingMixin(OnsiteConfigModel));

module.exports = new OnsiteConfigModel();
